var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useReducer, } from "@wordpress/element";
import { getUserPageUserDataRequest } from "../api/user-page-api";
import { SET_USER_PAGE_USER_DATA, SET_USER_PAGE_USER_LOADING, } from "../constants";
import { useErrorHandler } from "../hooks/useErrorHandler";
import { reducer } from "../reducers/user-page-user-recuder";
import { UserPageAppContext } from "./UserPageAppContextProvider";
const initialState = {
    user: null,
    customFields: [],
    loading: true,
};
const UserPageUserContext = createContext({
    state: initialState,
    useUserPageUserDispatch: () => { },
    loadUserData: () => { },
});
const UserPageUserContextProvider = ({ children, }) => {
    const [state, useUserPageUserDispatch] = useReducer(reducer, initialState);
    const { state: { pageHash }, } = useContext(UserPageAppContext);
    const { handleError } = useErrorHandler();
    useEffect(() => {
        if (pageHash) {
            loadUserData();
        }
    }, []);
    const loadUserData = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            useUserPageUserDispatch({
                type: SET_USER_PAGE_USER_LOADING,
                payload: true,
            });
            const response = yield getUserPageUserDataRequest(pageHash);
            useUserPageUserDispatch({
                type: SET_USER_PAGE_USER_DATA,
                payload: response.data,
            });
        }
        catch (error) {
            handleError(error);
        }
        finally {
            useUserPageUserDispatch({
                type: SET_USER_PAGE_USER_LOADING,
                payload: false,
            });
        }
    });
    return (_jsx(UserPageUserContext.Provider, { value: { state, useUserPageUserDispatch, loadUserData }, children: children }));
};
export { UserPageUserContext, UserPageUserContextProvider, };
